import { useTranslate } from '@va/localization';
import { ConfirmationDialogProps, ConfirmationModal } from '@va/shared/util-confirmation';
import { Paragraph } from '@va/ui/design-system';
import { useMemo } from 'react';

type DeleteConversationConfirmationModalProps = ConfirmationDialogProps & {
  chatName: string;
};

export const DeleteConversationConfirmationModal: React.FC<DeleteConversationConfirmationModalProps> = ({
  onClose,
  onConfirm,
  chatName,
}) => {
  const translate = useTranslate();

  const infoNode = useMemo(() => {
    return (
      <div>
        <Paragraph>{translate('aiChatbot.chatsHistory.confirmDelete.warning', { chatName })}</Paragraph>
      </div>
    );
  }, [chatName, translate]);

  return (
    <ConfirmationModal
      info={infoNode}
      title={translate('aiChatbot.chatsHistory.confirmDelete.title')}
      onClose={onClose}
      onConfirmation={onConfirm}
      isOpen={true}
      actionButtonText={translate('button.confirm')}
    />
  );
};
